module.exports = __webpack_public_path__ + "img/logo.465b5142.png";